import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Tests',
  components: {

  },
  props: {

  },
  emits: {
      
  },
})
export default class Tests extends Vue {
    
}
